module.exports = __webpack_public_path__ + "img/first-screen.9e603e2a.webp";